// Beeren levertijd-teller. Logica hoort bij snippets/beeren-levertijd.liquid.
// Staat bewust in een los asset en niet inline in het snippet: de "Snelle blik" op
// collectiepagina's kloont de productpagina via een <template>, en inline <script>-tags
// worden dan nooit uitgevoerd. Het thema laadt wel elke script[src] uit
// .section-main-product na, dus zo werkt de teller ook in de snelle blik.
(function () {
  if (customElements.get('beeren-levertijd')) return;

  var TZ = 'Europe/Amsterdam';
  var DAGEN = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];

  // Verschil (ms) tussen de echte klok en de servertijd van Shopify. Blijft 0 tot
  // de HEAD-call binnen is; de teller draait ondertussen gewoon door op de apparaatklok.
  var klokCorrectie = 0;
  var correctieGedaan = false;

  function ijkKlok() {
    if (correctieGedaan) return Promise.resolve();
    correctieGedaan = true;
    return fetch('/cart.js', { method: 'HEAD', cache: 'no-store' })
      .then(function (r) {
        var d = r.headers.get('Date');
        if (!d) return;
        var server = Date.parse(d);
        if (!isNaN(server)) klokCorrectie = server - Date.now();
      })
      .catch(function () { /* geen net? dan gewoon de apparaatklok */ });
  }

  function nu() { return new Date(Date.now() + klokCorrectie); }

  // Hoeveel ms loopt Amsterdam voor op UTC, op dit moment (regelt zomertijd).
  function amsOffset(d) {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    });
    var p = {};
    f.formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    var alsUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return alsUTC - Math.floor(d.getTime() / 1000) * 1000;
  }

  // Truc: tel de offset erbij op, dan geven de getUTC*-getters de Amsterdamse wandkloktijd.
  function naarAms(d) { return new Date(d.getTime() + amsOffset(d)); }
  function iso(d) {
    return d.getUTCFullYear() + '-' +
      String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(d.getUTCDate()).padStart(2, '0');
  }

  function config(el) {
    var cutoff = (el.dataset.cutoff || '17:00').split(':');
    return {
      uur: parseInt(cutoff[0], 10) || 17,
      minuut: parseInt(cutoff[1], 10) || 0,
      verzenddagen: (el.dataset.verzenddagen || '1,2,3,4,5')
        .split(',').map(function (n) { return parseInt(n, 10); })
        .filter(function (n) { return n >= 0 && n <= 6; }),
      feestdagen: (el.dataset.feestdagen || '').split(/[,;\s]+/).filter(Boolean)
    };
  }

  function isVerzenddag(amsDatum, cfg) {
    return cfg.verzenddagen.indexOf(amsDatum.getUTCDay()) !== -1 &&
           cfg.feestdagen.indexOf(iso(amsDatum)) === -1;
  }

  function plusDagen(amsDatum, n) {
    var d = new Date(amsDatum.getTime());
    d.setUTCDate(d.getUTCDate() + n);
    return d;
  }

  // Eerstvolgende dag waarop er écht een pakket weggaat.
  function verzenddatum(ams, cfg, voorCutoff) {
    if (voorCutoff && isVerzenddag(ams, cfg)) return ams;
    var d = ams;
    for (var i = 0; i < 14; i++) {
      d = plusDagen(d, 1);
      if (isVerzenddag(d, cfg)) return d;
    }
    return null;
  }

  function bereken(el) {
    var cfg = config(el);
    var echt = nu();
    var ams = naarAms(echt);

    // Het cutoff-moment van vandaag, terug in echte tijd.
    var cutoffAms = new Date(ams.getTime());
    cutoffAms.setUTCHours(cfg.uur, cfg.minuut, 0, 0);
    var cutoffEcht = cutoffAms.getTime() - amsOffset(echt);
    var resterend = cutoffEcht - echt.getTime();

    var voorCutoff = resterend > 0;
    var verzendt = verzenddatum(ams, cfg, voorCutoff);
    if (!verzendt) return null;

    var morgenIso = iso(plusDagen(ams, 1));

    return {
      telt: iso(verzendt) === iso(ams),
      resterend: resterend,
      cutoffLabel: String(cfg.uur).padStart(2, '0') + ':' + String(cfg.minuut).padStart(2, '0'),
      verzendLabel: iso(verzendt) === morgenIso ? 'morgen' : DAGEN[verzendt.getUTCDay()]
    };
  }

  function klok(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var u = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
    return u + ':' + String(m).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
  }

  class BeerenLevertijd extends HTMLElement {
    connectedCallback() {
      this.doel = this.querySelector('[data-levertijd-tekst]');
      if (!this.doel) return;
      ijkKlok().then(() => this.start());
      this.start();
    }

    disconnectedCallback() { clearInterval(this.timer); }

    start() {
      clearInterval(this.timer);
      this.teken();
      this.timer = setInterval(() => this.teken(), 1000);
    }

    teken() {
      var s = bereken(this);
      if (!s) { this.hidden = true; return; }

      if (s.telt) {
        this.doel.innerHTML =
          'Voor ' + s.cutoffLabel + ' besteld, <strong>vandaag verzonden!</strong> ' +
          'Je hebt nog <span class="beeren-levertijd__klok">' + klok(s.resterend) + '</span>';
      } else {
        this.doel.innerHTML =
          'Nu besteld? Dan verzenden wij <strong>' + s.verzendLabel + '</strong>.';
        clearInterval(this.timer);
        // Na de cutoff één keer per minuut kijken of we een nieuwe dag in rollen.
        this.timer = setInterval(() => this.teken(), 60000);
      }
    }
  }

  customElements.define('beeren-levertijd', BeerenLevertijd);
})();
